import { render, staticRenderFns } from "./add-media-modal.vue?vue&type=template&id=0ae8635e&scoped=true"
import script from "./add-media-modal.vue?vue&type=script&lang=js"
export * from "./add-media-modal.vue?vue&type=script&lang=js"
import style0 from "./add-media-modal.vue?vue&type=style&index=0&id=0ae8635e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8635e",
  null
  
)

export default component.exports